import apiClient from './api';
import toast from 'react-hot-toast';

/**
 * Sube una imagen al servidor y devuelve el media.
 * @param {File} imageFile El archivo de imagen a subir.
 * @returns {Promise<{url: string, publicId: string|null}>} El media subido.
 */
export const uploadImage = async (imageFile) => {
  if (!imageFile || !(imageFile instanceof File) || imageFile.size === 0) {
    toast.error('Archivo de imagen invalido.');
    throw new Error('Invalid image file');
  }
  const formData = new FormData();
  // 🟢 SOLUCIÓN: Usamos el nombre de campo 'media' que el backend espera.
  formData.append('media', imageFile);

  try {
    const response = await apiClient.post('/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return {
      url: response.data.url,
      publicId: response.data.publicId || response.data.public_id || null,
    };
  } catch (error) {
    // 🟢 SOLUCIÓN: En lugar de devolver null, relanzamos el error.
    // Esto permite que el componente que llamó a esta función (ImageUploader)
    // pueda capturarlo en su propio bloque catch y manejarlo adecuadamente.
    toast.error(error.response?.data?.message || 'Error al subir la imagen.');
    throw error;
  }
};

/**
 * Sube un video al servidor y devuelve la URL.
 * @param {File} videoFile El archivo de video a subir.
 * @returns {Promise<string|null>} La URL del video subido o null si hay un error.
 */
export const uploadVideo = async (videoFile) => {
  const formData = new FormData();
  formData.append('media', videoFile);

  try {
    const response = await apiClient.post('/media/upload/video', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.url;
  } catch (error) {
    toast.error(error.response?.data?.message || 'Error al subir el video.');
    throw error;
  }
};
